import $ from 'jquery';
import 'select2';
import axios from "axios";
import Alert from "../layout/Alert";
import "bootstrap-datepicker";

export default new class Api {

	constructor() {
		window.$ = window.jQuery = $;

		this.preloader = $(`<div id="preloader" class="modal-backdrop fade" style="z-index:99999">
    <div class="d-flex justify-content-center align-items-center h-100">
        <div class="spinner-border" role="status" style="width:5rem;height:5rem;">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</div>`).hide();
		$('body').append(this.preloader);
		this.preloaderTimer = null;

		axios.defaults.withCredentials = true;
		axios.defaults.xsrfCookieName = 'XSRF-TOKEN_' + window.CONFIG.appname;
	}

	listeners = [];

	addListener(cb) {
		this.listeners.push(cb);
	}

	put(url, obj, cb, successRedirect, hasFiles) {
		this.preloader.show();
		if (this.preloaderTimer) clearTimeout(this.preloaderTimer);
		this.preloaderTimer = setTimeout(() => {
			this.preloader.addClass('show');
		}, 300);
		let headers = { headers: { Version: t.appVersion } };
		let data = obj;
		if (hasFiles) {
			headers.onUploadProgress = progressEvent => {
				console.log(t.fileSize(progressEvent.loaded) + " / " + t.fileSize(progressEvent.total));
			};
			data = new FormData();
			let filesCount = 0, dataCount = 0;
			for (let key in obj) {
				if (obj[key] != null && typeof obj[key] == 'object' && obj[key].constructor.name == 'FileList') {
					let files = [];
					for (let i = 0; i < obj[key].length; i++) {
						files.push(obj[key][i]);
					}
					if (files.length) {
						data.append('Files[' + filesCount + '].Key', key);
						files.map(file => data.append('Files[' + filesCount + '].Value', file));
						filesCount++;
					}
				} else {
					data.append('Data[' + dataCount + '].Key', key);
					data.append('Data[' + dataCount + '].Value', obj[key]);
					dataCount++;
				}
			}
		}
		axios.put((window.CONFIG?.basename || "") + '/api/' + url, data, headers)
			.then(response => {
				if (response.data.messages) {
					for (let i in response.data.messages) {
						let message = response.data.messages[i];
						Alert(message.splice(1), message[0]);
					}
				}
				if (response.data.status == 'objectNotFound') {
					Alert("errorObjectNotFound", "error");
					if (!response.data.redirect)
						response.data.redirect = "/";
				}
				if (response.data.status == 'ok' && successRedirect && !response.data.redirect)
					response.data.redirect = successRedirect;
				let ok = true;
				for (let i in this.listeners) {
					ok &= this.listeners[i](response);
				}
				if (ok && cb)
					cb(response);
			})
			.catch(ex => {
				if (!ex.response && ex.isAxiosError)
					Alert("errorNoResponse", "error");
				else if (ex.response && ex.response.status == 401) {
					for (let i in this.listeners) {
						this.listeners[i](ex.response);
					}
					Alert(ex.response.data.message, "error");
				} else if (ex.response && ex.response.status == 400 && ex.response.data.message) {
					Alert(ex.response.data.message, "error")
					throw ex;
				} else {
					Alert("errorServerError", "error");
					throw ex;
				}
			})
			.finally(() => {
				clearTimeout(this.preloaderTimer);
				this.preloader.hide().removeClass('show');
			});
	}

	download(url, obj, cb) {
		this.preloader.show();
		if (this.preloaderTimer) clearTimeout(this.preloaderTimer);
		this.preloaderTimer = setTimeout(() => {
			this.preloader.addClass('show');
		}, 300);
		let headers = { headers: { Version: t.appVersion }, responseType: 'arraybuffer' };

		axios.put((window.CONFIG?.basename || "") + '/api/' + url, obj, headers)
			.then(response => {
				var a = document.createElement('a');
				var blob = new Blob([response.data], { type: response.headers['content-type'] });
				var url = window.URL.createObjectURL(blob);
				a.href = url;
				a.download = decodeURI(response.headers['content-disposition'].match(/filename[^;=\n]*\*=UTF-8''((['"]).*?\2|[^;\n]*)/)[1]);
				document.body.append(a);
				a.click();
				a.remove();
				window.URL.revokeObjectURL(url);
				if (cb)
					cb(response);
			})
			.catch(ex => {
				if (!ex.response && ex.isAxiosError)
					Alert("errorNoResponse", "error");
				else if (ex.response && ex.response.status == 401) {
					for (let i in this.listeners) {
						this.listeners[i](ex.response);
					}
					Alert("errorLoginExpired", "error");
				} else if (ex.response && ex.response.status == 400 && ex.response.data.indexOf("errorVersionMismatch") != -1) {
					Alert("errorVersionMismatch", "error")
					throw ex;
				} else {
					Alert("errorServerError", "error");
					throw ex;
				}
			})
			.finally(() => {
				clearTimeout(this.preloaderTimer);
				this.preloader.hide().removeClass('show');
			});
	}

	getParameter(name, defaultValue = '') {
		name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
		var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
		var results = regex.exec(location.search);
		return results === null ? defaultValue : decodeURIComponent(results[1].replace(/\+/g, ' '));
	}

}
